var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1VenetianBlindUpDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.11 11H39L28 22 17.11 11zM48 11L37 22h21.89L48 11zM17 33h42v-6H17v6zm0 10h42v-6H17v6zm0 10h42v-6H17v6zm0 10h42v-6H17",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Venetian_blind_up-down.9610d5c1.svg";
export { SvgC1VenetianBlindUpDown as ReactComponent };